// Module
var code = `<ex-ecran-qlik app="{{::vm.app}}" sheet="{{::vm.sheet}}" isapp="{{::vm.isapp}}"></ex-ecran-qlik> `;
// Exports
module.exports = code;